module.exports = __webpack_public_path__ + "media/img/illustrations/coworking-b22ecef104617474e48081a084e8d6f8.svg";